"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFICE_RESERVED_CREDITOR_ID = void 0;
__exportStar(require("./fechamento"), exports);
__exportStar(require("./preferences"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./commission"), exports);
__exportStar(require("./creditor"), exports);
__exportStar(require("./roa"), exports);
__exportStar(require("./customer_assets"), exports);
__exportStar(require("./backoffice"), exports);
__exportStar(require("./payment"), exports);
__exportStar(require("./company"), exports);
__exportStar(require("./office_preferences"), exports);
__exportStar(require("./sheet_db"), exports);
__exportStar(require("./document"), exports);
__exportStar(require("./backend"), exports);
__exportStar(require("./sheet_coordinates"), exports);
__exportStar(require("./permission_profile"), exports);
__exportStar(require("./login"), exports);
__exportStar(require("./creditor_payment_info"), exports);
__exportStar(require("./splitscript"), exports);
__exportStar(require("./oauth"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./payroll"), exports);
__exportStar(require("./webhooks"), exports);
__exportStar(require("./mail"), exports);
__exportStar(require("./document_signer"), exports);
__exportStar(require("./auth"), exports);
exports.OFFICE_RESERVED_CREDITOR_ID = 'ESCRITORIO';
